import { Feature } from "ol";
import { Extent, buffer } from "ol/extent";
import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import { BufferOp } from "jsts/org/locationtech/jts/operation/buffer";
import { getMap } from "../Forms/DrawingForm";
import { Vector as VectorSource } from "ol/source";
import { Vector as VectorLayer } from "ol/layer";
import { Fill, Stroke, Style } from "ol/style";
import { EsriJSON } from "ol/format";
import * as olGeom from "ol/geom";

export interface IEsriGeometry {
    rings: number[][][];
}

const esrijsonFormat = new EsriJSON();

// const parser = new OL3Parser();
// parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);

const parser = new OL3Parser(undefined, { geom: olGeom });

export const getBuffer = (feature: Feature, distance?: number): Extent =>
    buffer(feature.getGeometry().getExtent(), distance || 100);

export const cloneFeatures = (features: Feature[]): Feature[] => features.map((f) => f.clone());

export const getMultiPolygonGeometry = (features: Feature[]): IEsriGeometry => {
    const bufferFeatures = bufferizeFeatures(cloneFeatures(features), 5);
    // if you want to see buffers, use this function
    // visualizeBuffers(bufferFeatures);

    const geometries = bufferFeatures.map((f) => {
        const esriGeometry = esrijsonFormat.writeGeometry(f.getGeometry());
        return JSON.parse(esriGeometry).rings[0];
    });
    const rings = geometries.filter((geometry) => geometry.length); // removes empty rings, to prevent geometryService error
    const geom = { hasZ: false, hasM: false, rings };
    return geom;
};

export const bufferizeFeatures = (features: Feature[], distance?: number): Feature[] => {
    for (let i = 0; i < features.length; i += 1) {
        const jstsGeometry = parser.read(features[i].getGeometry());
        const bo = new BufferOp(jstsGeometry);
        const buffered = bo.getResultGeometry(distance || 10);
        const geometry = parser.write(buffered);

        features[i].setGeometry(geometry.simplify(4));
    }

    return features;
};

const createVectorLayer = (source: VectorSource) =>
    new VectorLayer({
        properties: { id: "visualize-buffers-layer" },
        source,
        style: () => {
            return new Style({
                fill: new Fill({ color: [0, 0, 255, 0.4] }),
                stroke: new Stroke({ color: "blue", width: 3 })
            });
        }
    });

const visualizeBuffers = (features: Feature[]) => getMap().addLayer(createVectorLayer(new VectorSource({ features })));

// const correct = {
//     geometry: {
//         hasZ: false,
//         hasM: false,
//         rings: [
//             [
//                 [596157.2331094847, 322357.22894464235],
//                 [596157.2331094847, 332646.0364424453],
//                 [602757.9152248361, 332646.0364424453],
//                 [602757.9152248361, 322357.22894464235],
//                 [596157.2331094847, 322357.22894464235]
//             ]
//         ]
//     },
//     GeometryType: "esriGeometryPolygon",
//     fields: ["LVMFORESTRYCODE", "LVMFORESTRYNAME", "SHAPEAREA", "SHAPELEN"]
// };

// const incorrect = {
//     geometry: {
//         hasZ: false,
//         hasM: false,
//         rings: [
//             [
//                 [595772.6977991455, 310958.76506262395],
//                 [595772.6977991455, 321729.51403244026],
//                 [615422.5758015744, 321729.51403244026],
//                 [615422.5758015744, 310958.76506262395],
//                 [595772.6977991455, 310958.76506262395]
//             ]
//         ]
//     },
//     GeometryType: "esriGeometryPolygon",
//     fields: ["LVMFORESTRYCODE", "LVMFORESTRYNAME", "SHAPEAREA", "SHAPELEN"]
// };

// const longlineKurzemeVidzeme = {
//     geometry: {
//         hasZ: false,
//         hasM: false,
//         rings: [
//             [
//                 [450912.41915133246, 306605.04871076025],
//                 [450912.41915133246, 340788.9363454527],
//                 [564137.2960747214, 340788.9363454527],
//                 [564137.2960747214, 306605.04871076025],
//                 [450912.41915133246, 306605.04871076025]
//             ]
//         ]
//     },
//     GeometryType: "esriGeometryPolygon",
//     fields: ["LVMFORESTRYCODE", "LVMFORESTRYNAME", "SHAPEAREA", "SHAPELEN"]
// };
